import script from "./UserMySetting.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMySetting.vue?vue&type=script&setup=true&lang=js"

import "./UserMySetting.vue?vue&type=style&index=0&id=6a8d043f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a8d043f"]])

export default __exports__